(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aurina-sar-price"] && !Shopify.designMode) return;
  try {
    const COUNTRY_TO_CURRENCY = Object.freeze({"AC":"SHP","AD":"EUR","AE":"AED","AF":"AFN","AG":"XCD","AI":"XCD","AL":"ALL","AM":"AMD","AO":"AOA","AQ":"USD","AR":"ARS","AS":"USD","AT":"EUR","AU":"AUD","AW":"AWG","AX":"EUR","AZ":"AZN","BA":"BAM","BB":"BBD","BD":"BDT","BE":"EUR","BF":"XOF","BG":"EUR","BH":"BHD","BI":"BIF","BJ":"XOF","BL":"EUR","BM":"BMD","BN":"BND","BO":"BOB","BQ":"USD","BR":"BRL","BS":"BSD","BT":"BTN","BV":"NOK","BW":"BWP","BY":"BYN","BZ":"BZD","CA":"CAD","CC":"AUD","CD":"CDF","CF":"XAF","CG":"XAF","CH":"CHF","CI":"XOF","CK":"NZD","CL":"CLP","CM":"XAF","CN":"CNY","CO":"COP","CR":"CRC","CU":"CUP","CV":"CVE","CW":"XCG","CX":"AUD","CY":"EUR","CZ":"CZK","DE":"EUR","DG":"USD","DJ":"DJF","DK":"DKK","DM":"XCD","DO":"DOP","DZ":"DZD","EA":"EUR","EC":"USD","EE":"EUR","EG":"EGP","EH":"MAD","ER":"ERN","ES":"EUR","ET":"ETB","EU":"EUR","FI":"EUR","FJ":"FJD","FK":"FKP","FM":"USD","FO":"DKK","FR":"EUR","GA":"XAF","GB":"GBP","GD":"XCD","GE":"GEL","GF":"EUR","GG":"GBP","GH":"GHS","GI":"GIP","GL":"DKK","GM":"GMD","GN":"GNF","GP":"EUR","GQ":"XAF","GR":"EUR","GS":"GBP","GT":"GTQ","GU":"USD","GW":"XOF","GY":"GYD","HK":"HKD","HM":"AUD","HN":"HNL","HR":"EUR","HT":"HTG","HU":"HUF","IC":"EUR","ID":"IDR","IE":"EUR","IL":"ILS","IM":"GBP","IN":"INR","IO":"USD","IQ":"IQD","IR":"IRR","IS":"ISK","IT":"EUR","JE":"GBP","JM":"JMD","JO":"JOD","JP":"JPY","KE":"KES","KG":"KGS","KH":"KHR","KI":"AUD","KM":"KMF","KN":"XCD","KP":"KPW","KR":"KRW","KW":"KWD","KY":"KYD","KZ":"KZT","LA":"LAK","LB":"LBP","LC":"XCD","LI":"CHF","LK":"LKR","LR":"LRD","LS":"ZAR","LT":"EUR","LU":"EUR","LV":"EUR","LY":"LYD","MA":"MAD","MC":"EUR","MD":"MDL","ME":"EUR","MF":"EUR","MG":"MGA","MH":"USD","MK":"MKD","ML":"XOF","MM":"MMK","MN":"MNT","MO":"MOP","MP":"USD","MQ":"EUR","MR":"MRU","MS":"XCD","MT":"EUR","MU":"MUR","MV":"MVR","MW":"MWK","MX":"MXN","MY":"MYR","MZ":"MZN","NA":"NAD","NC":"XPF","NE":"XOF","NF":"AUD","NG":"NGN","NI":"NIO","NL":"EUR","NO":"NOK","NP":"NPR","NR":"AUD","NU":"NZD","NZ":"NZD","OM":"OMR","PA":"PAB","PE":"PEN","PF":"XPF","PG":"PGK","PH":"PHP","PK":"PKR","PL":"PLN","PM":"EUR","PN":"NZD","PR":"USD","PS":"ILS","PT":"EUR","PW":"USD","PY":"PYG","QA":"QAR","RE":"EUR","RO":"RON","RS":"RSD","RU":"RUB","RW":"RWF","SA":"SAR","SB":"SBD","SC":"SCR","SD":"SDG","SE":"SEK","SG":"SGD","SH":"SHP","SI":"EUR","SJ":"NOK","SK":"EUR","SL":"SLE","SM":"EUR","SN":"XOF","SO":"SOS","SR":"SRD","SS":"SSP","ST":"STN","SV":"USD","SX":"XCG","SY":"SYP","SZ":"SZL","TA":"GBP","TC":"USD","TD":"XAF","TF":"EUR","TG":"XOF","TH":"THB","TJ":"TJS","TK":"NZD","TL":"USD","TM":"TMT","TN":"TND","TO":"TOP","TR":"TRY","TT":"TTD","TV":"AUD","TW":"TWD","TZ":"TZS","UA":"UAH","UG":"UGX","UM":"USD","US":"USD","UY":"UYU","UZ":"UZS","VA":"EUR","VC":"XCD","VE":"VES","VG":"USD","VI":"USD","VN":"VND","VU":"VUV","WF":"XPF","WS":"WST","XK":"EUR","YE":"YER","YT":"EUR","ZA":"ZAR","ZM":"ZMW","ZW":"ZWG"});
const EMBEDDED_RATES = Object.freeze({"AED":3.6725,"AFN":66.234,"ALL":81.97,"AMD":366.77,"AOA":916.38,"ARS":1488.45,"AUD":1.4411,"AWG":1.7955,"AZN":1.6997,"BAM":1.7111,"BBD":2.0409,"BDT":123.23,"BHD":0.376,"BIF":2992.89,"BMD":1,"BND":1.2923,"BOB":8.5549,"BRL":5.1146,"BSD":1.0135,"BTN":95.44,"BWP":13.3502,"BYN":2.8615,"BZD":2.0406,"CAD":1.4159,"CDF":2257.84,"CHF":0.80805,"CLP":926.32,"CNY":6.7756,"COP":3256.66,"CRC":454.1,"CUP":24,"CVE":96.47,"CZK":21.227,"DJF":177.09,"DKK":6.5418,"DOP":59.876,"DZD":133.26,"EGP":49.817,"ERN":15.3479,"ETB":159.28,"EUR":0.87489,"FJD":2.2378,"FKP":0.74607,"GBP":0.74607,"GEL":2.6317,"GHS":11.5724,"GIP":0.7578,"GMD":72.44,"GNF":8066,"GTQ":7.6409,"GYD":212.97,"HKD":7.8474,"HNL":26.815,"HTG":130.73,"HUF":312.03,"IDR":18071,"ILS":3.0153,"INR":95.44,"IQD":1310.2,"IRR":1372263,"ISK":125.54,"JMD":156.79,"JOD":0.709,"JPY":162.07,"KES":129.07,"KGS":87.48,"KHR":4037.28,"KMF":431.39,"KPW":129.99,"KRW":1501.59,"KWD":0.30839,"KYD":0.83722,"KZT":468.8,"LAK":22494,"LBP":92370,"LKR":334.45,"LRD":181.64,"LYD":6.4093,"MAD":9.3396,"MDL":17.5482,"MGA":4257.07,"MKD":53.962,"MMK":2100.07,"MNT":3582.93,"MOP":8.0828,"MRU":40,"MUR":47.178,"MVR":15.3719,"MWK":1738.5,"MXN":17.501,"MYR":4.0725,"MZN":63.434,"NAD":16.3555,"NGN":1390.05,"NIO":36.777,"NOK":9.7634,"NPR":152.68,"NZD":1.7341,"OMR":0.3845,"PAB":1.0013,"PEN":3.3973,"PGK":4.4152,"PHP":61.573,"PKR":278.79,"PLN":3.7937,"PYG":6080,"QAR":3.64,"RON":4.5806,"RSD":102.72,"RUB":76.637,"RWF":1469.17,"SAR":3.75,"SBD":8.0955,"SCR":14.2109,"SDG":600.7,"SEK":9.6513,"SGD":1.2923,"SHP":0.74607,"SLE":24.247,"SOS":572.29,"SRD":37.65,"SSP":4784.72,"STN":21.518,"SYP":122.08,"SZL":16.3762,"THB":33.35,"TJS":9.2497,"TMT":3.5,"TND":2.9518,"TOP":2.3831,"TRY":46.967,"TTD":6.76,"TWD":32.124,"TZS":2624.68,"UAH":44.568,"UGX":3686.88,"USD":1,"UYU":40.268,"UZS":12065,"VES":712.08,"VND":26189,"VUV":118.76,"WST":2.7342,"XAF":573.89,"XCD":2.7537,"XCG":1.795,"XOF":573.89,"XPF":104.62,"YER":238.64,"ZAR":16.3254,"ZMW":18.0649,"ZWG":26.85});
const CACHE_KEY = 'aurina-usd-local-rates-v1';
const COUNTRY_CACHE_KEY = 'aurina-detected-country-v1';
const CACHE_TTL = 12 * 60 * 60 * 1000;
const COUNTRY_CACHE_TTL = 12 * 60 * 60 * 1000;
const MAX_STALE = 7 * 24 * 60 * 60 * 1000;
const PRIMARY_URL = 'https://api.frankfurter.dev/v2/rates?base=USD';
const FALLBACK_URL = 'https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/usd.min.json';
const SECONDARY_FALLBACK_URL = 'https://latest.currency-api.pages.dev/v1/currencies/usd.min.json';
const EMBEDDED_SNAPSHOT = {
  fetchedAt: Date.parse('2026-07-14T00:00:00Z'),
  sourceDate: '2026-07-14',
  rates: EMBEDDED_RATES,
};
let currentSnapshot = selectInitialSnapshot();
let detectedCountry = readCachedCountry();
let refreshPromise;
let refreshScheduled = false;
let countryDetectionPromise;
let countryDetectionScheduled = false;

function isRatesObject(value) {
  return Boolean(value && typeof value === 'object' && Number(value.USD) === 1);
}

function isUsableSnapshot(value, maxAge = MAX_STALE) {
  if (!value || !isRatesObject(value.rates) || !Number.isFinite(Number(value.fetchedAt))) return false;
  return Math.abs(Date.now() - Number(value.fetchedAt)) <= maxAge;
}

function readCachedSnapshot() {
  try {
    const value = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
    return isUsableSnapshot(value) ? value : null;
  } catch {
    return null;
  }
}

function selectInitialSnapshot() {
  const cached = readCachedSnapshot();
  const embedded = isUsableSnapshot(EMBEDDED_SNAPSHOT) ? EMBEDDED_SNAPSHOT : null;
  if (!cached) return embedded;
  if (!embedded) return cached;
  return Number(cached.fetchedAt) >= Number(embedded.fetchedAt) ? cached : embedded;
}

function writeCachedSnapshot(value) {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(value));
  } catch {
    return;
  }
}

function readCachedCountry() {
  try {
    const value = JSON.parse(localStorage.getItem(COUNTRY_CACHE_KEY) || 'null');
    const country = String(value?.country || '').toUpperCase();
    const age = Date.now() - Number(value?.fetchedAt);
    return /^[A-Z]{2}$/.test(country) && age >= 0 && age <= COUNTRY_CACHE_TTL ? country : '';
  } catch {
    return '';
  }
}

function writeCachedCountry(country) {
  try {
    localStorage.setItem(COUNTRY_CACHE_KEY, JSON.stringify({ country, fetchedAt: Date.now() }));
  } catch {
    return;
  }
}

function getCurrency(element) {
  const country = detectedCountry || String(element.dataset.country || '').toUpperCase();
  return COUNTRY_TO_CURRENCY[country] || '';
}

function getFractionDigits(currency) {
  try {
    return new Intl.NumberFormat('en', { style: 'currency', currency }).resolvedOptions().maximumFractionDigits;
  } catch {
    return 2;
  }
}

function formatNumber(value, currency, locale, compact = false) {
  if (compact && Math.abs(value) >= 1000000) {
    try {
      return new Intl.NumberFormat('en', {
        notation: 'compact',
        compactDisplay: 'short',
        maximumFractionDigits: 1,
        numberingSystem: 'latn',
      }).format(value);
    } catch {
      return `${(value / 1000000).toFixed(1)}M`;
    }
  }
  const digits = getFractionDigits(currency);
  try {
    return new Intl.NumberFormat(locale || 'en', {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
      numberingSystem: 'latn',
      useGrouping: true,
    }).format(value);
  } catch {
    return value.toFixed(digits);
  }
}

function getLocalLabel(element) {
  if (!currentSnapshot) return null;
  const currency = getCurrency(element);
  const baseCurrency = String(element.dataset.baseCurrency || '').toUpperCase();
  const priceCents = Number(element.dataset.priceCents);
  const rate = Number(currentSnapshot.rates[currency]);
  if (!currency || currency === baseCurrency || baseCurrency !== 'USD') return null;
  if (!Number.isFinite(priceCents) || !Number.isFinite(rate) || rate <= 0) return null;
  const compact = element.classList?.contains('aurina-sar-price--compact') || false;
  const amount = formatNumber((priceCents / 100) * rate, currency, element.dataset.locale, compact);
  const template = element.dataset.valueTemplate || '≈ __amount__ __currency__';
  return {
    currency,
    text: template.split('__amount__').join(amount).split('__currency__').join(currency),
  };
}

function setRelatedVisibility(element, visible) {
  const container = element.closest('[data-aurina-local-container]');
  if (container) container.hidden = !visible;
  const scope = element.closest('.cart-totals__container, [ref="priceContainer"]') || element.parentElement;
  scope?.querySelectorAll('[data-aurina-local-note]').forEach((note) => {
    note.hidden = !visible;
  });
}

function updateAllLocalCurrencyElements() {
  document.querySelectorAll('aurina-local-price, aurina-local-property').forEach((element) => {
    if (typeof element.updateLocalCurrency === 'function') element.updateLocalCurrency();
  });
}

async function fetchJson(url, timeout = 3500) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeout);
  try {
    const response = await fetch(url, {
      headers: { Accept: 'application/json' },
      signal: controller.signal,
    });
    if (!response.ok) throw new Error('Currency service unavailable');
    return await response.json();
  } finally {
    clearTimeout(timer);
  }
}

function normalizeFrankfurter(payload) {
  if (!Array.isArray(payload)) throw new Error('Invalid Frankfurter response');
  const rates = { USD: 1 };
  let sourceDate = '';
  payload.forEach((row) => {
    const currency = String(row?.quote || '').toUpperCase();
    const rate = Number(row?.rate);
    if (/^[A-Z]{3}$/.test(currency) && Number.isFinite(rate) && rate > 0) rates[currency] = rate;
    if (typeof row?.date === 'string' && row.date > sourceDate) sourceDate = row.date;
  });
  return { fetchedAt: Date.now(), sourceDate, rates };
}

function normalizeFawaz(payload) {
  if (!payload || typeof payload !== 'object' || !payload.usd) throw new Error('Invalid fallback response');
  const rates = { USD: 1 };
  Object.entries(payload.usd).forEach(([code, rawRate]) => {
    const currency = String(code).toUpperCase();
    const rate = Number(rawRate);
    if (/^[A-Z]{3}$/.test(currency) && Number.isFinite(rate) && rate > 0) rates[currency] = rate;
  });
  return { fetchedAt: Date.now(), sourceDate: String(payload.date || ''), rates };
}

async function loadFreshSnapshot() {
  try {
    return normalizeFrankfurter(await fetchJson(PRIMARY_URL));
  } catch {
    try {
      return normalizeFawaz(await fetchJson(FALLBACK_URL));
    } catch {
      return normalizeFawaz(await fetchJson(SECONDARY_FALLBACK_URL));
    }
  }
}

function refreshRates() {
  if (refreshPromise) return refreshPromise;
  refreshPromise = loadFreshSnapshot()
    .then((snapshot) => {
      if (!isRatesObject(snapshot.rates)) return;
      currentSnapshot = snapshot;
      writeCachedSnapshot(snapshot);
      updateAllLocalCurrencyElements();
    })
    .catch(() => undefined)
    .finally(() => {
      refreshPromise = undefined;
    });
  return refreshPromise;
}

function detectCountry() {
  if (countryDetectionPromise) return countryDetectionPromise;
  const root = window.Shopify?.routes?.root || '/';
  const currentCountry = String(window.Shopify?.country || '').toUpperCase();
  const exclusion = /^[A-Z]{2}$/.test(currentCountry)
    ? `&country[exclude]=${encodeURIComponent(currentCountry)}`
    : '';
  const url = `${root}browsing_context_suggestions.json?country[enabled]=true${exclusion}`;
  countryDetectionPromise = fetchJson(url, 3000)
    .then((payload) => {
      const country = String(payload?.detected_values?.country?.handle || '').toUpperCase();
      if (!COUNTRY_TO_CURRENCY[country]) return;
      detectedCountry = country;
      writeCachedCountry(country);
      updateAllLocalCurrencyElements();
    })
    .catch(() => undefined)
    .finally(() => {
      countryDetectionPromise = undefined;
    });
  return countryDetectionPromise;
}

function runWhenIdle(callback) {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(callback, { timeout: 1500 });
  } else {
    setTimeout(callback, 0);
  }
}

function scheduleCountryDetection() {
  if (detectedCountry || countryDetectionScheduled || countryDetectionPromise) return;
  countryDetectionScheduled = true;
  const start = () => {
    countryDetectionScheduled = false;
    runWhenIdle(() => detectCountry());
  };
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
}

function scheduleRefresh() {
  if (refreshScheduled || refreshPromise) return;
  if (currentSnapshot && Date.now() - Number(currentSnapshot.fetchedAt) <= CACHE_TTL) return;
  refreshScheduled = true;
  const start = () => {
    refreshScheduled = false;
    runWhenIdle(() => refreshRates());
  };
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
}

class AurinaLocalPrice extends HTMLElement {
  static observedAttributes = ['data-price-cents', 'data-country', 'data-base-currency'];

  connectedCallback() {
    this.updateLocalCurrency();
    scheduleCountryDetection();
    scheduleRefresh();
  }

  attributeChangedCallback() {
    if (this.isConnected) this.updateLocalCurrency();
  }

  updateLocalCurrency() {
    const local = getLocalLabel(this);
    if (!local) {
      this.hidden = true;
      this.dataset.aurinaState = 'unavailable';
      setRelatedVisibility(this, false);
      return;
    }
    this.textContent = local.text;
    this.hidden = false;
    this.dataset.currency = local.currency;
    this.dataset.rateDate = currentSnapshot?.sourceDate || '';
    this.dataset.aurinaState = 'ready';
    setRelatedVisibility(this, true);
  }
}

class AurinaLocalProperty extends HTMLElement {
  static observedAttributes = ['data-price-cents', 'data-country', 'data-base-currency'];

  connectedCallback() {
    this.eventRoot = this.closest('.shopify-section, dialog') || document;
    this.eventRoot.addEventListener('shopify:product:select', this.handleProductSelect);
    this.updateLocalCurrency();
    scheduleCountryDetection();
    scheduleRefresh();
  }

  disconnectedCallback() {
    this.eventRoot?.removeEventListener('shopify:product:select', this.handleProductSelect);
  }

  attributeChangedCallback() {
    if (this.isConnected) this.updateLocalCurrency();
  }

  handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || !event.promise) return;
    const ownCard = this.closest('product-card');
    const sourceCard = event.target.closest('product-card');
    if ((ownCard || sourceCard) && ownCard !== sourceCard) return;
    event.promise
      .then(({ detail }) => {
        const owner = this.closest('product-form-component');
        if (detail?.productId && owner?.dataset.productId && String(detail.productId) !== owner.dataset.productId) return;
        const price = Number(detail?.resource?.price);
        if (Number.isFinite(price)) this.dataset.priceCents = String(price);
      })
      .catch(() => undefined);
  };

  updateLocalCurrency() {
    const input = this.querySelector('input[data-aurina-local-property]');
    if (!input) return;
    const local = getLocalLabel(this);
    input.disabled = !local;
    input.value = local?.text || '';
  }
}

if (!customElements.get('aurina-local-price')) customElements.define('aurina-local-price', AurinaLocalPrice);
if (!customElements.get('aurina-local-property')) customElements.define('aurina-local-property', AurinaLocalProperty);
  } catch(e) { console.error(e); }
})();

})();
